/* Preview stub — generated for the KCC branding live-preview lift of Studies + TopNavbar.
   No backend in this app; these inert modules satisfy the lifted components' imports. */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
 "isUserGuideModalVisible": false
};

const sliceObj = createSlice({
	name: "userGuide",
	initialState,
	reducers: {
		setIsUserGuideModalVisible: (_state, _action: PayloadAction<any>) => {},
	},
});

export const { setIsUserGuideModalVisible } = sliceObj.actions;
export default sliceObj.reducer;
